export const get_money_transfer = `query get_money_transfer($id: String!){
    get_money_transfer(id: $id){
        transaction_code
        status
        from_account
        to_account
        currency{
            currency
            name
            decimal
        }
        amount
        order_date
        fulfillment_date
    }
}`;
